{
  "name": "@chancenwerk/chancen-akademie",
  "displayName": "ChancenAkademie",
  "description": "The ChancenAkademie is the internal course management service of the Chancenwerk e.V.",
  "version": "1.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/ass": "catalog:",
    "@adornis/config": "catalog:",
    "@adornis/base": "catalog:",
    "@adornis/baseql": "catalog:",
    "@adornis/fonts": "catalog:",
    "@adornis/chemistry": "catalog:",
    "@adornis/cms": "catalog:",
    "@adornis/data-view": "catalog:",
    "@adornis/file-utils": "catalog:",
    "@adornis/filter": "catalog:",
    "@adornis/forms": "catalog:",
    "@adornis/functional-lit": "catalog:",
    "@adornis/internationalization": "catalog:",
    "@adornis/router": "catalog:",
    "@adornis/user-forms": "catalog:",
    "@adornis/users": "catalog:",
    "@adornis/validation": "catalog:",
    "@adornis/writer": "catalog:",
    "@chancenwerk/routes": "workspace:*",
    "@chancenwerk/shared": "workspace:*",
    "@chancenwerk/server": "workspace:*",
    "@chancenwerk/config": "workspace:*",
    "@chancenwerk/enums": "workspace:*",
    "@chancenwerk/client": "workspace:*",
    "@chancenwerk/translation-data": "workspace:*",
    "@lit-labs/preact-signals": "catalog:",
    "construct-style-sheets-polyfill": "catalog:",
    "lit": "catalog:",
    "mingo": "catalog:",
    "rxjs": "catalog:",
    "luxon": "catalog:"
  },
  "devDependencies": {
    "@adornis/cli": "catalog:"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
